import { Component } from '@angular/core'

@Component({
  standalone: false,
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
})
export class PortalComponent {}
